import * as React from 'react';
export const Facebook = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M14.25 4.5H18V0h-3.75A5.256 5.256 0 009 5.25V7.5H6V12h3v12h4.5V12h3.75L18 7.5h-4.5V5.25a.76.76 0 01.75-.75z" />
  </svg>
);
